/**
 * Normalises the brand word to lowercase "fiid" in visible storefront copy.
 * Text nodes only (no DOM structure changes) — layout stays the same.
 * Skips scripts, form controls, and SVG so layout and behaviour stay intact.
 * Add data-fiid-brand-skip on a subtree to opt out.
 */
(function () {
  var SKIP_TAGS = {
    SCRIPT: 1,
    STYLE: 1,
    NOSCRIPT: 1,
    TEMPLATE: 1,
    IFRAME: 1,
    CODE: 1,
    PRE: 1,
    TEXTAREA: 1,
    INPUT: 1,
    SELECT: 1,
    OPTION: 1,
    SVG: 1,
  };

  function shouldSkipTextNode(node) {
    var el = node.parentElement;
    if (!el) return true;
    if (el.closest('[data-fiid-brand-skip]')) return true;
    var tag = el.tagName;
    if (SKIP_TAGS[tag]) return true;
    if (el.closest('svg')) return true;
    return false;
  }

  function replaceInRoot(root) {
    if (!root || !root.nodeType) return;
    try {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          if (shouldSkipTextNode(node)) return NodeFilter.FILTER_REJECT;
          if (!node.nodeValue || !/fiid/i.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        },
      });
      var n;
      while ((n = walker.nextNode())) {
        n.nodeValue = n.nodeValue.replace(/\bFiid\b/gi, 'fiid');
      }
    } catch (e) {
      /* no-op */
    }
  }

  function run() {
    replaceInRoot(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev && ev.target) replaceInRoot(ev.target);
  });
})();
